import { z } from "zod";
import { RequestChannelSchema, RequestStatusSchema } from "./requests";

export const RequestCalendarItemSchema = z.object({
  id: z.string(),
  requestId: z.string(),
  title: z.string(),
  status: RequestStatusSchema,
  /** yyyy-MM-dd */
  date: z.string(),
  customerName: z.string().nullable(),
  channel: RequestChannelSchema,
  priorityOrder: z.number().nullable(),
  assignedToName: z.string().nullable().optional(),
});
export type RequestCalendarItemDTO = z.infer<typeof RequestCalendarItemSchema>;

export const RequestCalendarTbdItemSchema = z.object({
  requestId: z.string(),
  title: z.string(),
  status: RequestStatusSchema,
  customerName: z.string().nullable(),
  channel: RequestChannelSchema,
  priorityOrder: z.number().nullable(),
  assignedToName: z.string().nullable().optional(),
});
export type RequestCalendarTbdItemDTO = z.infer<
  typeof RequestCalendarTbdItemSchema
>;

export const RequestCalendarQuerySchema = z.object({
  start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  status: z.string().optional(),
  title: z.string().optional(),
  channel: z.string().optional(),
  assignedTo: z.string().optional(),
  priorityOnly: z
    .union([z.literal("true"), z.literal("false"), z.boolean()])
    .optional()
    .transform((value) => value === true || value === "true"),
});
export type RequestCalendarQueryDTO = z.infer<
  typeof RequestCalendarQuerySchema
>;

export const RequestCalendarResponseSchema = z.object({
  items: z.array(RequestCalendarItemSchema),
  tbdRequests: z.array(RequestCalendarTbdItemSchema),
});
export type RequestCalendarResponseDTO = z.infer<
  typeof RequestCalendarResponseSchema
>;
